'use client';

import NextError from 'next/error';
import { useEffect } from 'react';
import type { ReactElement } from 'react';
import posthogJs from 'posthog-js';
import { captureBrowserException, getNextPublicPostHogEnv } from '@monorepo/posthog/browser';

const postHogEnv = getNextPublicPostHogEnv();
const postHogOptions = { serviceName: 'armstrong' };

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}): ReactElement {
  useEffect(() => {
    captureBrowserException(
      posthogJs,
      error,
      {
        source: 'global-error',
        digest: error.digest,
      },
      postHogEnv,
      postHogOptions
    );
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
